/**
 * Local "thinking" placeholder shown in place of the next assistant reply,
 * from the moment a turn is sent until the real streaming message doc
 * appears. Past a defensive timeout, `useOptimisticTurns` flips the turn to
 * 'error' instead (see `lib/optimisticMessages.ts#THINKING_TIMEOUT_MS`), so
 * this placeholder is swapped out for the error bubble rather than lingering
 * indefinitely.
 *
 * Visually identical to the in-place typing indicator `MessageBubble` already
 * renders for a `status: 'streaming'` message with no body yet — this is the
 * same state, just before that Firestore doc exists on the client.
 */
import { Monogram } from '@/components/brand/logo'
import { TypingDots } from '@/components/chat/typing-dots'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'

export function ThinkingBubble() {
  return (
    <div className="flex gap-3">
      <Avatar className="border-border bg-card mt-0.5 size-7 shrink-0 border">
        <AvatarFallback className="bg-card">
          <Monogram size={16} title="Agente Executivo" />
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1 space-y-1.5">
        <div className="bg-card border-border w-fit rounded-2xl rounded-tl-sm border px-3.5 py-2">
          <TypingDots />
        </div>
      </div>
    </div>
  )
}
